import type { ChatMessage } from '../../shared/protocol';

/**
 * Player messages after the last entry this browser has seen; everything
 * counts when nothing has been read yet. System lines narrate membership the
 * Players tab already shows, so they never raise the badge.
 */
export function countUnreadAfter(
  messages: readonly Readonly<ChatMessage>[],
  lastReadId: string | null,
): number {
  const index = lastReadId === null ? -1 : messages.findIndex((message) => message.id === lastReadId);
  let unread = 0;
  for (const message of messages.slice(index + 1)) if (message.kind !== 'system') unread += 1;
  return unread;
}
